module.exports = __webpack_public_path__ + "img/C05TechAuxiliaCamp_Upgrade1_ua.310b2507.webp";